import * as React from 'react';

const customStyle = {
  display: 'flex',
  overflow: 'auto',
  // flexDirection: 'column',
  padding: 0,
  flex: '0 1 auto',
};

const BodyWrapper = (props) => {
  const Class = `m__body ` + (props.className ? props.className : '');
  return (
    <div
      className={Class}
    >
      {props.children}
    </div>
  )
};

export default BodyWrapper;

